import { Components, Theme } from "@mui/material/styles";

export const MuiPaper = () =>
  ({
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "unset",
        },
      },
    },
  }) satisfies Components<Theme>;
